import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { PhnSubscriptionPlanInterface } from '../../store/callrecorder/phnSubscriptionPlansSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.phnSubscriptionPlanPath(value.id)
  };
}

export const phnSubscriptionPlansEntity = new schema.Entity(
  'phn_subscription_plans',
  {},
  {
    processStrategy
  }
);

export const phnSubscriptionPlanEntity = new schema.Entity(
  'phn_subscription_plan',
  {},
  {
    processStrategy
  }
);

const fetchPhnSubscriptionPlansCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      phn_subscription_plans: { [key: string]: PhnSubscriptionPlanInterface };
    }
  >(response.data.phn_subscription_plans, [phnSubscriptionPlansEntity]);

  return {
    phnSubscriptionPlans: normalized.entities?.phn_subscription_plans || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { phn_subscription_plan: PhnSubscriptionPlanInterface; }
  >(response.data.phn_subscription_plan, phnSubscriptionPlanEntity);
  return normalized.entities;
}

export const fetchPhnSubscriptionPlans = createAsyncThunk(
  `${PREFIX}_phn_subscription_plans/fetchPhnSubscriptionPlans`,
  async (params: object = {}) => fetchPhnSubscriptionPlansCollection('/onesky/phn_subscription_plans', params)
);

export const fetchPhnSubscriptionPlan = createAsyncThunk(
  `${PREFIX}_phn_subscription_plans/fetchPhnSubscriptionPlan`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/phn_subscription_plans/${id}`);
    return normalizeInstance(response);
  }
);

export const createPhnSubscriptionPlan = createAsyncThunk(
  `${PREFIX}_phn_subscription_plans/createPhnSubscriptionPlan`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.post(`/onesky/phn_subscription_plans`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updatePhnSubscriptionPlan = createAsyncThunk(
  `${PREFIX}_phn_subscription_plans/updatePhnSubscriptionPlan`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.patch(`/onesky/phn_subscription_plans/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
